import { render, staticRenderFns } from "./HotSpot.vue?vue&type=template&id=0f06e69d&scoped=true&"
import script from "./HotSpot.vue?vue&type=script&lang=js&"
export * from "./HotSpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f06e69d",
  null
  
)

export default component.exports